import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './veiculoActions';

class VeiculoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='placa'
								component={LabelAndInput}
								label='Placa *' placeholder='Informe'
								cols='12 1 1 1'
								readOnly={readOnly}
								minWidth={150} />

							<Field
								name='codigo_integracao'
								component={LabelAndInput}
								label='Código de Integração' placeholder='Informe'
								cols='12 2 2 2'
								readOnly={readOnly} />
						</Row>
						<Row>								
							<Field
								name='id_transportadora'
								options={this.props.listaTransportadora}
								component={Select}
								label='Transportadora' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly}
								value={this.props.formularioValues.id_transportadora}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										id_transportadora: value,
										id_motorista: null
									})
								}} />
						</Row>
						<Row>								
							<Field
								name='id_motorista'
								options={this.props.listaMotorista.filter(item => 
									(!this.props.formularioValues.id_transportadora && !item.id_transportadora)
									|| item.id_transportadora == this.props.formularioValues.id_transportadora
								)}
								component={Select}
								label='Motorista' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>						
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

}

VeiculoForm = reduxForm({form: 'veiculoForm', destroyOnUnmount: false})(VeiculoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('veiculoForm')(state),
	registro: state.veiculo.registro,
	listaTransportadora: state.transportadora.listaSelect,
	listaMotorista: state.motorista.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VeiculoForm);
